export default "__VITE_ASSET__xBz3j9AAj0dCUhi0Glx7Ow__"